import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35542b94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-menu-single-logout flex" }

import {useUser} from '@/logged/features/user';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderSingleLogout',
  setup(__props) {

    const userStore = useUser();

    async function handleLogout() {
        await userStore.logoutUser();
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_button = _resolveComponent("joy-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_joy_button, {
      variant: "ghost",
      onClick: handleLogout
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$msg('navbar.aside.tabs.title.freelancer.logout')), 1)
      ]),
      _: 1
    })
  ]))
}
}

})